module.exports = __webpack_public_path__ + "img/Comic_33.b2c453a5.png";